<template>
  <div class="user">
    <div class="user-img">
      <img :src="avatar|getAvator"/>
    </div>
  </div>
</template>


<script>
export default {
  props: ['avatar'],
  data() {
    return {
      comment: ''
    };
  },

};
</script>

<style scoped lang="scss">
$browser-default-font-size: 16px !default;
@function pxTorem($px) {
  @return $px / $browser-default-font-size * 1rem;
}

//@mixin recursive-item-right($cur,$end) {
//   .user.img:nth-child(#{$cur}) {
//       position: relative;
//       z-index: 9;
//       right: -#{($end - $cur+1) * 6}px;
//   }
//   @if $end > $cur {
//     @include recursive-item-right($cur+1, $end);
//   }
// }
// .uList-3 {
//   @include recursive-item-right(1,3);
// }
//
// .uList-2 {
//   @include recursive-item-right(1,2);
// }
//
// .uList-1 {
//   @include recursive-item-right(1,1);
// }

.user {
  width: 24px;
  line-height: 24px;
}

.user-img img {
  width: 24px;
  line-height: 24px;
  border-radius: 50%;
}

/*.img {*/
/*  width: 20px;*/
/*  height: 20px;*/
/*}*/
/*.img .user-img {*/
/*  height: 20px;*/
/*  width: 20px;*/
/*}*/
.img .user-img img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
</style>
